export function validPhone(field) {
    const phone = /^[0-9]{3}-?[0-9]{3}-?[0-9]{4}$/;
    return phone.test(field.value) ? true : false;
}
